"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralRewardThresholdTrackerToJSON = exports.ReferralRewardThresholdTrackerFromJSONTyped = exports.ReferralRewardThresholdTrackerFromJSON = void 0;
var _1 = require("./");
function ReferralRewardThresholdTrackerFromJSON(json) {
    return ReferralRewardThresholdTrackerFromJSONTyped(json, false);
}
exports.ReferralRewardThresholdTrackerFromJSON = ReferralRewardThresholdTrackerFromJSON;
function ReferralRewardThresholdTrackerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'referralRelationship': (0, _1.ReferralRelationshipFromJSON)(json['referralRelationship']),
        'referralRewardThreshold': (0, _1.ReferralRewardThresholdFromJSON)(json['referralRewardThreshold']),
    };
}
exports.ReferralRewardThresholdTrackerFromJSONTyped = ReferralRewardThresholdTrackerFromJSONTyped;
function ReferralRewardThresholdTrackerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'referralRelationship': (0, _1.ReferralRelationshipToJSON)(value.referralRelationship),
        'referralRewardThreshold': (0, _1.ReferralRewardThresholdToJSON)(value.referralRewardThreshold),
    };
}
exports.ReferralRewardThresholdTrackerToJSON = ReferralRewardThresholdTrackerToJSON;
